import axios from 'axios';
import util from 'util/baseUtil';

const stock = function() {
  
  const CancelToken = axios.CancelToken;
  let source = CancelToken.source();
  let sourceDetail = CancelToken.source();
  
  // const apiHost = process.env.REACT_APP_MOEME_API_HOST;

  /**
   * ajax 요청 취소
   */
  function cancelRequest() {
    source.cancel('cancel');
    source = CancelToken.source();

    sourceDetail.cancel('cancel');
    sourceDetail = CancelToken.source();
  }


  /**
   * ajax 종목상세 요청 취소
   */
  function cancelRequestDetail() {
    sourceDetail.cancel('cancel');
    sourceDetail = CancelToken.source();
  }


  /**
   * 모이미 종목 이슈 리스트
   */
  async function getListIssueStock() {
    let response = await axios.post(`/api/stock/getIssueStockRanking`, null, {cancelToken: source.token});
    return response.data;
  }


  /**
   * 종목 상세 데이터
   */
  async function getStockData(params) {
    let response = await axios.post(`/api/stock/getStockData`, util.convertToURLParams(params), {cancelToken: sourceDetail.token});
    return response.data;
  }


  /**
   * 종목 뉴스, 공시
   */
  async function getStockPosting(params) {
    let response = await axios.post(`/api/stock/getStockPosting`, util.convertToURLParams(params), {cancelToken: sourceDetail.token});
    return response.data;
  }


  /**
   * 종목 통계 데이터
   */
  async function getStockStats(params) {
    let response = await axios.post(`/api/stock/getStockStats`, util.convertToURLParams(params), {cancelToken: sourceDetail.token});
    return response.data;
  }
  
  
  /**
   * 전체 종목 코드 리스트
   * @param {URLSearchParams} params 요청 파라미터 { corp_code: 기업코드, page_count: 페이지수(기본3) }
   */
  async function getListStockCode() {
    let response = await axios.get(`http://file1.wave.aveapp.com:8007/file/api/down_proc.jsp?type=17&d=mst&serverfile=stkcode.csv`, {cancelToken: source.token});
    return response.data;
  }




  return {
    cancelRequest: cancelRequest,
    cancelRequestDetail: cancelRequestDetail,
    getListIssueStock: getListIssueStock,
    getStockData: getStockData,
    getStockPosting: getStockPosting,
    getStockStats: getStockStats,
    getListStockCode: getListStockCode,
  }
}()


export default stock;